<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">旅行与拍摄</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goAdmissionFee">
        <div class="module_left" style="width: 180px;">手机买门票</div>
        <div class="module_right_icon1 AdmissionFee1">
          <div class="module_right_icon2 AdmissionFee2">
            <div class="module_right_icon3 AdmissionFee3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goHotel">
        <div class="module_left">预定酒店</div>
        <div class="module_right_icon1 Hotel1">
          <div class="module_right_icon2 Hotel2">
            <div class="module_right_icon3 Hotel3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goGroup">
        <div class="module_left">手机报团</div>
        <div class="module_right_icon1 Group1">
          <div class="module_right_icon2 Group2">
            <div class="module_right_icon3 Group3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goPhoto">
        <div class="module_left">照片拍摄</div>

        <div class="module_right_icon1 Photo1">
          <div class="module_right_icon2 Photo2">
            <div class="module_right_icon3 Photo3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goVideo">
        <div class="module_left">视频拍摄</div>

        <div class="module_right_icon1 Video1">
          <div class="module_right_icon2 Video2">
            <div class="module_right_icon3 Video3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},

  mounted() {},
  beforeDestroy() {},

  methods: {
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
    async goAdmissionFee() {
      this.$router.push({
        path: "/travel/admissionFee/index",
      });
    },

    async goPhoto() {
      this.$router.push({
        path: "/travel/photo/index1",
      });
    },
    async goVideo() {
      this.$router.push({
        path: "/travel/video/index1",
      });
    },
    async goHotel() {
      this.$router.push({
        path: "/travel/hotel/index",
      });
    },

    async goGroup() {
      this.$router.push({
        path: "/travel/group/index",
      });
    },
  },
};
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 粉色 */
  background: linear-gradient(
    180deg,
    rgb(255, 114, 156) 6.107%,
    rgb(255, 150, 181) 20.611%,
    rgb(255, 239, 227) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 20px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 48vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 30px;
    top: 40px;
    z-index: 0;
    width: 340px;
    height: 270px;
    background: url(@/assets/travel/travelIndex/travelIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 30px;

  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 325px;
    padding: 27px 0;
    height: 95px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }

    .AdmissionFee1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AdmissionFee2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AdmissionFee3 {
      background: url("@/assets/travel/travelIndex/admissionFee.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .Hotel1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Hotel2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Hotel3 {
      background: url("@/assets/travel/travelIndex/hotel.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Group1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Group2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Group3 {
      background: url("@/assets/travel/travelIndex/group.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Photo1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Photo2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Photo3 {
      background: url("@/assets/travel/travelIndex/photo.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Video1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Video2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Video3 {
      background: url("@/assets/travel/travelIndex/video.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
